// extracted by mini-css-extract-plugin
export default {"container":"X60rAl","isResized":"ZpvoXO","slider":"mlq02z","empty":"ocbIzD","emptyContent":"b2Fjfy","navButton":"fJkLE6","shadyNav":"nFhWJh","player":"U4lvrX","active":"OtdGWP"};